import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { transferPackagesInRange } from '../../../actions/qtActions';
import DriverLookupInput from '../DriverLookupInput';

import { 
    TextField, Button
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { showAlertSnackbar, getSelectedBatchIds } from '../../../reducers/uiSlice';
import FullscreenLoading from '../../../components/Common/FullscreenLoading';
import { useTranslation } from 'react-i18next';
import { assignServicePoint, getDriverServicePoint } from '../../../actions/dropOffActions';

const AdvancedTransfer = (props) => {
    const {classes, dispatch, userCity, searchList, driverListTemp} = props;
    const {t} = useTranslation('quickTransfer');
    
    const batchIDs = useSelector(getSelectedBatchIds);
    const servicePointListArr = useSelector(state => state.servicePoint.getServicePoint);

    const [transferDriverName, setTransferDriverName] = useState('...');
    const [transferDriverId, setTransferDriverId] = useState('');
    const [selectionBegin, setSelectionBegin] = useState(0);
    const [selectionEnd, setSelectionEnd] = useState(0);
    const [routeNumber, setRouteNumber] = useState('');
    const [batchNumber, setBatchNumber] = useState((batchIDs.length === 1) ? batchIDs[0] : '');
    const [defaultBatchFlag, setDefaultBatchFlag] = useState((batchIDs.length === 1));
    const [submitLoading, setSubmitLoading] = useState(false);
    const [servicePointId, setServicePointId] = useState('');
    const [lastDropOff, setLastDropOff] = useState('');
    const [servicePointList, setServicePointList] = useState([{name: t('not_applicable'), id: '-1', total_dropoff: -1, storage_space: 0}])

    const handleReset = () => {
        setTransferDriverName('...');
        setTransferDriverId('');
        setSelectionBegin(0);
        setSelectionEnd(0);
        setRouteNumber('');
        setBatchNumber((batchIDs.length === 1) ? batchIDs[0] : '');
        setDefaultBatchFlag((batchIDs.length === 1));
    }

    const checkSubmitArgs = () => {
        let valid = true;

        if (
            batchNumber === '' ||
            routeNumber === '' ||
            selectionBegin === 0 ||
            selectionEnd === 0 ||
            transferDriverId === ''
        ) {
            valid = false;
        }

        return valid;
    }

    const handleSubmit = async () => {
        if (checkSubmitArgs()) {
            try {
                setSubmitLoading(true);
                let res = await dispatch(transferPackagesInRange(batchNumber, routeNumber, selectionBegin, selectionEnd, transferDriverId,'group_pickup'))
                dispatch(showAlertSnackbar({title: t('title_quick_transfer'), 
                    message: `${t('input')} ${selectionEnd - selectionBegin + 1} ${t('order')}，${t('transfer')} ${res.updated} ${t('order')}`, 
                    type: 'success',
                    duration: 6000
                }));
                if(servicePointId) {
                    dispatch(assignServicePoint(transferDriverId, servicePointId));
                }
            } catch {
                dispatch(showAlertSnackbar({title: t('title_quick_transfer'), 
                    message: `${t('import_correct_info')}`, 
                    type: 'error',
                    duration: 6000
                }));
            } finally {
                setSubmitLoading(false);
            }
        }
    };

    useEffect(() => {
        setServicePointId('');
    }, [])
    useEffect(() => {
        if(transferDriverId) {
            dispatch(getDriverServicePoint(transferDriverId))
            .then((res) => {
                setLastDropOff(res.name);
            })
            .catch(() => {
                setLastDropOff(t('not_set_yet'));
            })
        }
    }, [transferDriverId])
    useEffect(() => {
        if(servicePointListArr) {
            if(servicePointListArr.length > 0) {
                let arr = [{name: t('not_applicable'), id: '-1', total_dropoff: -1, storage_space: 0}];
                servicePointListArr.map((servicePoint) => {
                    arr.push(servicePoint);
                })
                setServicePointList(arr);
            }
        }
    }, [servicePointListArr])

    return (<>
        
        <div className={classes.driverStyle}>
            <TextField multiline className={classes.textfieldBatchStyle}
                variant='outlined'
                size='small'
                autoFocus={!defaultBatchFlag}
                value={batchNumber}
                onChange={ (e) => {setBatchNumber(e.target.value)} }
                label={t('batch_number')}
            />
        </div>

        <div className={classes.driverStyle}>
            <TextField multiline className={classes.textfieldBatchStyle}
                variant='outlined'
                size='small'
                autoFocus={defaultBatchFlag}
                value={routeNumber}
                onChange={ (e) => {setRouteNumber(e.target.value)} }
                label={t('route_number')}
            />
        </div>

        <div className={classes.driverStyle} style={{ display: 'flex' }}>

            <span className={classes.titleStyle} 
                style={{ paddingTop: 8, paddingRight: 10 }}
            >
                {t('start')}
            </span>
            <TextField className={classes.textfieldBatchStyle}
                variant="outlined"
                size="small"
                type='number'
                value={selectionBegin || ''}
                style={{ maxWidth: '100px' }}
                onChange={ (e) => {setSelectionBegin(e.target.value)} }
            />

            <div style={{ marginLeft: 'auto', marginRight: 0 }}/>
            <span className={classes.titleStyle} 
                style={{ paddingTop: 8, paddingRight: 10 }}
            >
                {t('end')}
            </span>
            <TextField className={classes.textfieldBatchStyle}
                variant="outlined"
                size="small"
                type='number'
                value={selectionEnd || ''}
                style={{ maxWidth: '100px' }}
                onChange={ (e) => {setSelectionEnd(e.target.value)} }
            />
            
        </div>

        <div className={classes.driverStyle}>
            <DriverLookupInput classes={classes}
                userCity={userCity}
                searchList={searchList}
                driverListTemp={driverListTemp}
                transferDriverName={transferDriverName}
                setTransferDriverName={setTransferDriverName}
                transferDriverId={transferDriverId}
                setTransferDriverId={setTransferDriverId}
            />
        </div>
        {
            servicePointList &&
            <Autocomplete
                options={servicePointList}
                getOptionLabel={(option) => option.name}
                // getOptionDisabled={(option) => option.total_dropoff >= option.storage_space}
                style={{ marginTop: 30 }}
                renderInput={(params) => (
                    <TextField {...params} label={t("destined_drop_off_required")} variant="outlined" />
                )}
                onChange={(event, newValue) => {
                    if(!newValue) {
                        setServicePointId('');
                        return;
                    }
                    setServicePointId(newValue.id);
                }}
                renderOption={(option) => (
                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                        <div>{option.name}</div>
                        <div
                            style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: 300
                            }}
                        >{option.company}</div>
                        {
                            option.id !== '-1' &&
                            <div>{option.total_dropoff}/{option.storage_space}</div>
                        }
                    </div>
                )}
            />
        }
        <div style={{fontSize: 13, color: '#fff', marginTop: 6}}>
            {t('last_location') + lastDropOff}
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 99}}>
            <Button
                variant='contained' 
                color='primary'
                onClick={handleReset}
            >
                {t('common:reset')}
            </Button>

            <Button
                disabled={!servicePointId || transferDriverName === '...' || !transferDriverName}
                variant='contained' 
                color='secondary'
                onClick={handleSubmit}
            >
                {t('common:submit')}
            </Button>
        </div>

        <FullscreenLoading open={submitLoading}/>
    </>);
}

export default AdvancedTransfer;